import _misc from "@/assets/utils/misc.js"

export function transformTaxes (taxes, totalToPay, discount = 0) {
    if (!taxes) return []

    let taxArr = []
    Object.entries(taxes).forEach(tax => {
        switch (tax[0]) {
            case 'absolute' :
                break;
            case 'byPerson' :
                break;
            case 'percentage' :
                    taxArr.push(transformPercentage(tax[0], tax[1], totalToPay))
                break;
            default :
                break;
        }
    })

    return taxArr
}

function transformPercentage (taxName, tax, totalToPay) {
    if (!tax) return {}
    return {...tax, 
            ...{name : taxName, 
                transformedValue : `${tax.value}%`,
                calculatedValue : _misc.truncateDecimals( (tax.value * totalToPay) / 100 ) }
            }
}